// @flow
import * as React from 'react';

const Card = (props: {
  children: React.Node,
  className?: string,
  verticalSpacing?: number,
}) => {
  const {
    className: propClassName = '',
    children,
    verticalSpacing = 4,
    ...rest
  } = props;
  const className = `mv${verticalSpacing} bg-white br1 ${propClassName}`;

  return (
    <div
      className={className}
      {...rest}
      style={{ boxShadow: '0 2px 2px 0 rgba(0,0,0,.24)' }}
    >
      {children}
    </div>
  );
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card.js